export const exportFarmerColumns = [
  { field: "farmerId", title: "Farmer ID" },
  { field: "farmerName", title: "Farmer Name" },
  { field: "tripId", title: "Trip ID" },
  { field: "date", title: "Date" },
  { field: "commodity", title: "Commodity" },
  { field: "weight", title: "Total Weight" },
  { field: "rate", title: "Rate" },
  { field: "total", title: "Total" },
];

export const exportDriverColumns = [
  { field: "driverId", title: "Driver ID" },
  { field: "driverName", title: "Driver Name" },
  { field: "tripId", title: "Trip ID" },
  { field: "date", title: "Date" },
  { field: "distance", title: "Distance Covered" },
  { field: "total", title: "Total" },
];
